module.exports = __webpack_public_path__ + "img/3D.690d5a47.png";